// extracted by css-extract-rspack-plugin
export default {"requiredOption":"requiredOption-VtIW6e"};